import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useQuickPaginationContext } from 'ui/components/nav/Pagination/QuickPagination';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

import c from '../utils/constants';

interface Payload {
  stageId: string;
  id: string;
}

export default function useUpdateDealStage() {
  const { setStageId } = useQuickPaginationContext() ?? {};
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation<any, ApiError, Payload, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v1/sales/deals/${payload.id}/status`,
            payload: { stageId: payload.stageId },
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals/${payload.id}/status`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: (successData) => {
      setStageId?.(successData?.stageId);

      queryClient.invalidateQueries([
        c.PIPELINES,
        successData?.data.pipelineId,
        c.DEALS,
      ]);

      queryClient.invalidateQueries([c.LOGS, successData?.data?._id]);

      toastSuccess('Successfully updated deal.');
    },
  });
}
